/* Minimalist inline SVG brand marks. Mono/duotone only — kept small so they
 * render crisp in the checkout payment rows. Not the official corporate
 * marks; each is a recognisable text-lockup drawn to match brand color. */

export const VisaLogo = () => (
  <svg
    viewBox="0 0 40 14"
    className="h-5 w-auto"
    data-testid="brand-logo-visa"
    aria-label="Visa"
  >
    <rect width="40" height="14" fill="#1a1f71" rx="2" />
    <text
      x="50%"
      y="55%"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="#ffffff"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="900"
      fontStyle="italic"
      fontSize="9"
      letterSpacing="0.5"
    >
      VISA
    </text>
  </svg>
);

export const MastercardLogo = () => (
  <svg
    viewBox="0 0 32 20"
    className="h-5 w-auto"
    data-testid="brand-logo-mastercard"
    aria-label="Mastercard"
  >
    <circle cx="12" cy="10" r="7" fill="#eb001b" />
    <circle cx="20" cy="10" r="7" fill="#f79e1b" />
    <path
      d="M16 4.6 A 7 7 0 0 1 16 15.4 A 7 7 0 0 1 16 4.6"
      fill="#ff5f00"
    />
  </svg>
);

export const AmexLogo = () => (
  <svg
    viewBox="0 0 40 14"
    className="h-5 w-auto"
    data-testid="brand-logo-amex"
    aria-label="American Express"
  >
    <rect width="40" height="14" fill="#2e77bb" rx="2" />
    <text
      x="50%"
      y="55%"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="#ffffff"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="900"
      fontSize="7"
      letterSpacing="0.4"
    >
      AMEX
    </text>
  </svg>
);

export const PayPalLogo = () => (
  <svg
    viewBox="0 0 60 16"
    className="h-5 w-auto"
    data-testid="brand-logo-paypal"
    aria-label="PayPal"
  >
    <text
      x="0"
      y="12"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="900"
      fontStyle="italic"
      fontSize="12"
      fill="#003087"
    >
      Pay
    </text>
    <text
      x="22"
      y="12"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="900"
      fontStyle="italic"
      fontSize="12"
      fill="#009cde"
    >
      Pal
    </text>
  </svg>
);

export const StripeLogo = () => (
  <svg
    viewBox="0 0 50 16"
    className="h-5 w-auto"
    data-testid="brand-logo-stripe"
    aria-label="Stripe"
  >
    <rect width="50" height="16" fill="#635bff" rx="3" />
    <text
      x="50%"
      y="55%"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="#ffffff"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="900"
      fontStyle="italic"
      fontSize="9"
    >
      stripe
    </text>
  </svg>
);

// Map used by Checkout.jsx to render logos beside each payment method row.
export const BRAND_LOGOS = {
  visa: VisaLogo,
  mastercard: MastercardLogo,
  amex: AmexLogo,
  paypal: PayPalLogo,
  stripe: StripeLogo,
};
